import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_ecomsync_item_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  mkt_guid: fromDatatype.GuidDataFieldInterface;
  mkt_item_id: fromDatatype.VarcharDatatypeInterface;
  mkt_seller_sku: fromDatatype.VarcharDatatypeInterface;
  mkt_item_name: fromDatatype.VarcharDatatypeInterface;
  mkt_item_status: fromDatatype.StatusDataFieldInterface;
  mkt_category: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  mkt_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  attributes?: {};
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  amount: fromDatatype.NumericDatatypeInterface;
  quantity: fromDatatype.NumericDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  ccy_code:  fromDatatype.VarcharDatatypeInterface;
  ccy_xrate: fromDatatype.VarcharDatatypeInterface;
  scan_code: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  txn_class: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  price_json: fromDatatype.JsonDatatypeInterface;
  options_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  dim_width: fromDatatype.NumericDatatypeInterface;
  dim_height: fromDatatype.NumericDatatypeInterface;
  dim_length: fromDatatype.NumericDatatypeInterface;
  dim_weight: fromDatatype.NumericDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  emp_status: fromDatatype.StatusDataFieldInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  sub_item_type: fromDatatype.VarcharDatatypeInterface;
  ecomsync_parent_hdr_guid : fromDatatype.VarcharDatatypeClass;
  mkt_shop_sku: fromDatatype.VarcharDatatypeClass;
  branch_list: fromDatatype.JsonDatatypeInterface;
  sales_order_list: fromDatatype.JsonDatatypeInterface;
  mode_config: fromDatatype.VarcharDatatypeClass;
  sales_order_config: fromDatatype.VarcharDatatypeClass;
  qty_balance: fromDatatype.NumericDatatypeInterface;
  buffer_config: fromDatatype.VarcharDatatypeClass;
  qty_buffer: fromDatatype.NumericDatatypeInterface;
  mkp_seller_stock_bal_qty : fromDatatype.NumericDatatypeInterface;
  mkp_seller_available_qty : fromDatatype.NumericDatatypeInterface;
  mkp_seller_buffer : fromDatatype.NumericDatatypeInterface;
  mkp_open_seller_order_qty: fromDatatype.NumericDatatypeInterface;
  percentage: fromDatatype.NumericDatatypeInterface;
  mkt_sku_id: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme_overwrite: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme: fromDatatype.GuidDataFieldInterface;
  pricing_scheme_item_link_guid: fromDatatype.GuidDataFieldInterface;
  override_branch_stock_config: fromDatatype.VarcharDatatypeInterface;
  main_image_guid: fromDatatype.GuidDataFieldInterface;
  cp_commerce_free_shipping: boolean;
  not_copy_from_fi_item_name: boolean;
}

export class bl_fi_mst_ecomsync_item_hdr_RowClass implements bl_fi_mst_ecomsync_item_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  mkt_guid: fromDatatype.GuidDataFieldInterface;
  mkt_item_id: fromDatatype.VarcharDatatypeInterface;
  mkt_seller_sku: fromDatatype.VarcharDatatypeInterface;
  mkt_item_name: fromDatatype.VarcharDatatypeInterface;
  mkt_item_status: fromDatatype.StatusDataFieldInterface;
  mkt_category: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  mkt_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  attributes?: {};
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  amount: fromDatatype.NumericDatatypeInterface;
  quantity: fromDatatype.NumericDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  ccy_code:  fromDatatype.VarcharDatatypeInterface;
  ccy_xrate: fromDatatype.VarcharDatatypeInterface;
  scan_code: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  txn_class: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  price_json: fromDatatype.JsonDatatypeInterface;
  options_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  dim_width: fromDatatype.NumericDatatypeInterface;
  dim_height: fromDatatype.NumericDatatypeInterface;
  dim_length: fromDatatype.NumericDatatypeInterface;
  dim_weight: fromDatatype.NumericDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  emp_status: fromDatatype.StatusDataFieldInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  sub_item_type: fromDatatype.VarcharDatatypeInterface;
  ecomsync_parent_hdr_guid : fromDatatype.VarcharDatatypeClass;
  mkt_shop_sku: fromDatatype.VarcharDatatypeClass;
  branch_list: fromDatatype.JsonDatatypeInterface;
  sales_order_list: fromDatatype.JsonDatatypeInterface;
  mode_config: fromDatatype.VarcharDatatypeClass;
  sales_order_config: fromDatatype.VarcharDatatypeClass;
  qty_balance: fromDatatype.NumericDatatypeInterface;
  buffer_config: fromDatatype.VarcharDatatypeClass;
  qty_buffer: fromDatatype.NumericDatatypeInterface;
  mkp_seller_stock_bal_qty : fromDatatype.NumericDatatypeInterface;
  mkp_seller_available_qty : fromDatatype.NumericDatatypeInterface;
  mkp_seller_buffer : fromDatatype.NumericDatatypeInterface;
  mkp_open_seller_order_qty: fromDatatype.NumericDatatypeInterface;
  percentage: fromDatatype.NumericDatatypeInterface;
  mkt_sku_id: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme_overwrite: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme: fromDatatype.GuidDataFieldInterface;
  pricing_scheme_item_link_guid: fromDatatype.GuidDataFieldInterface;
  override_branch_stock_config: fromDatatype.VarcharDatatypeInterface;
  main_image_guid: fromDatatype.GuidDataFieldInterface;
  is_pre_order: boolean;
  cp_commerce_free_shipping: boolean;
  not_copy_from_fi_item_name: boolean;
}
